import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { PUBLIC } from 'router/constants/routes';

import { sendAnalyticLoginHeaderClick } from 'services/analytics';

import { useSelector } from 'react-redux';

import Logo from 'components/Logo';
import { Text } from 'components/library';

import * as S from './styled';
import { isAuthenticatedSelector } from 'store/auth/selectors';

const HeaderPublic = () => {
    const isAuthenticated = useSelector(isAuthenticatedSelector);
    const { pathname } = useLocation();
    const { t } = useTranslation();

    const isRoot = pathname === PUBLIC.LOGIN.path;

    return (
        <S.HeaderPublicContainer>
            <S.TitleContainer>
                <Logo />
            </S.TitleContainer>

            {!isRoot && !isAuthenticated && (
                <S.LogInLink to="/" onClick={sendAnalyticLoginHeaderClick}>
                    <Text color="text-main" type="small-button">
                        {t('basics.login')}
                    </Text>
                </S.LogInLink>
            )}
        </S.HeaderPublicContainer>
    );
};

export default HeaderPublic;
